import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';
@Component({
  selector: 'app-work-experience',

  templateUrl: './work-experience.component.html',
  styleUrls: ['./work-experience.component.css'],
})
export class WorkExperienceComponent {
  @Input() formGroup!: FormGroup;

  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  constructor(private fb: FormBuilder) {}
  ngOnInit(): void {
    if (!this.formGroup.get('experiences') || this.experiences.length === 0) {
      this.formGroup.addControl('experiences', this.fb.array([]));
      this.addExperience();
    }
  }
  get experiences(): FormArray {
    return this.formGroup.get('experiences') as FormArray;
  }
  addExperience(): void {
    const experienceGroup = this.fb.group({
      title: ['', Validators.required],
      company: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: [''],
      isCurrent: [false],
      objective: ['', Validators.required],
    });
    this.experiences.push(experienceGroup);
  }
  removeExperience(index: number): void {
    this.experiences.removeAt(index);
  }
  onNext() {
    this.next.emit();
  }
  onPrevious() {
    this.previous.emit();
  }
}
